
export default {
  name: "TableCityPrices",

  props: {
    head: {
      type: Array,
      default: () => {
        return [
            'Грузоподъемность:',
            '1,5 т.',
            '3,5 т.',
            '5 т.',
            '10 т.',
            '20 т.',
        ]
      }
    },
    rows: {
      type: Array,
      default: () => {
        return []
      }
    },

    annotation: {
      type: String,
      default: ""
    },
    anotationMessage: {
      type: String,
      default: ""
    },

    rowHover: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AnotationMessage: () => import("~/components/routes/AnotationMessage")
  },

  methods: {
    clickRows: function (row) {
      if (!this.rowHover) {
        return
      }
      this.$emit("clickRows", row);
    }
  }
}
